import React, {useState, useEffect} from 'react';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
}


function CStaffCarousel(props) {
    const isMobile = useIsMobile();

   
    
  return (
    <>  
    {isMobile && (
        <div class="container text-center">
            <div class="row align-items-start">
                
                    <div class="card" style={{width: "90%", margin: "auto", marginBottom: "5%"}}>
                       
                        <div class="card-body">
                        <strong><p class="card-text">Commanding Officer</p></strong>
                        <p>{props.CCOname}</p>
                        </div>
                    </div>
                
                
                    <div class="card" style={{width: "90%", margin: "auto", marginBottom: "5%"}}>
                        
                        <div class="card-body">
                        <strong><p class="card-text">Executive Officer</p></strong>
                        <p>{props.CXOname}</p>
                        </div>
                    </div>
                
                
                    <div class="card" style={{width: "90%", margin: "auto", marginBottom: "5%"}}>
                        
                        <div class="card-body">
                            <strong><p class="card-text">First Sergeant</p></strong>
                            <p>{props.CFSname}</p>
                        </div>
                    </div>
                
            </div>
        </div>
    )}  
    {!isMobile && (
        <div class="container text-center">
            <div class="row align-items-start">
                <div class="col">
                    <div class="card" style={{width: "105%"}}>
                       
                        <div class="card-body">
                        <strong><p class="card-text">Commanding Officer</p></strong>
                        <p>{props.CCOname}</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card" style={{width: "105%"}}>
                        
                        <div class="card-body">
                        <strong><p class="card-text">Executive Officer</p></strong>
                        <p>{props.CXOname}</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card" style={{width: "105%"}}>
                        
                        <div class="card-body">
                            <strong><p class="card-text">First Sergeant</p></strong>
                            <p>{props.CFSname}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )}
    </>
  );
}

export default  CStaffCarousel;